
   

import { useCallback, useContext, useEffect, useState } from 'react'
import stores from '../state';
import Parse from 'parse'
import { base } from './usePlanners';
import axios from 'axios';

export const useNews = (article_id?:string,author?:string) => { 
    const [news,setNews] = useState<{article_id:string,title:string,img:string,time:string,content:string}[]>()
    const callback = useCallback(async ()=>{
        try{
            console.log('useNews',article_id,author)
            if(article_id){
                const {data} = await axios(base+'article/'+article_id+ '?r='+new Date().getTime())
                setNews([data])
            }else if(author){
                const {data} = await axios(base+`article/author/${author}?r=`+new Date().getTime())
                setNews(data)
            }
        }catch(e){
            console.error('usePractice',e)
        }  
    },[article_id,author])
    useEffect(()=>{
        callback()  
    },[callback])
    return news
} 
  
 